import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Archive, Edit, MoreVert, Visibility } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton } from '@mui/material';

interface BasicMenuProps {
    onDelete: () => void;
    onEdit: () => void;
    onViewMore?: () => void;
    isWhite?: boolean;
    isArchived?: boolean;
    fontSize?: 'small' | 'medium' | 'large';
    disabled?: boolean;
}

export default function BasicMenu({ 
    onDelete, 
    onEdit, 
    onViewMore, 
    isWhite, 
    isArchived, 
    fontSize,
    disabled = false 
}: BasicMenuProps) {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (disabled) return;
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <IconButton
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                sx={{ 
                    padding: 0.5,
                    opacity: disabled ? 0.5 : 1,
                    cursor: disabled ? 'not-allowed' : 'pointer'
                }}
                disabled={disabled}
            >
                <MoreVert sx={{ color: isWhite ? "white" : "inherit" }} fontSize={fontSize} />
            </IconButton>

            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                {onViewMore && (
                    <MenuItem
                        onClick={() => {
                            handleClose();
                            onViewMore();
                        }}
                    >
                        <Visibility sx={{ mr: 1.5 }} /> Ver mais
                    </MenuItem>
                )}

                {isArchived ? (
                    <MenuItem
                        onClick={() => {
                            handleClose();
                            onDelete();
                        }}
                    >
                        <Archive sx={{ mr: 1.5 }} /> Arquivar
                    </MenuItem>
                ) : (
                    <MenuItem
                        onClick={() => {
                            handleClose();
                            onDelete();
                        }}
                    >
                        <DeleteIcon sx={{ mr: 1.5 }} /> Excluir
                    </MenuItem>
                )}

                <MenuItem
                    onClick={() => {
                        handleClose();
                        onEdit();
                    }}
                >
                    <Edit sx={{ mr: 1.5 }} /> Editar
                </MenuItem>
            </Menu>
        </div>
    );
}